import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";

const LimitedLiabilityPartnership = () => {
  return (
    <div
      className="llp-page"
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        id="llp-header"
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: "30px 20px",
          fontSize: "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Limited Liability Partnership
      </div>

      {/* Intro Paragraph */}
      <p
        className="llp-intro"
        style={{
          maxWidth: "1200px",
          width: "95%",
          margin: "20px auto",
          padding: "20px",
        }}
      >
        A Limited Liability Partnership (LLP) is a popular business structure
        that offers limited liability protection to partners while maintaining
        low compliance costs. It blends the flexibility of a partnership with
        the structured benefits of a company.
      </p>

      {/* Content */}
      <div
        className="llp-container"
        style={{
          maxWidth: "1200px",
          width: "95%",
          margin: "15px auto",
          padding: "20px",
        }}
      >
        <div
          className="llp-card"
          style={{
            background: "white",
            padding: "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
            wordBreak: "break-word",
            hyphens: "auto",
          }}
        >
          {/* About LLP */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: "6px",
                fontFamily: "Times New Roman, Georgia, serif",
              }}
            >
              About Limited Liability Partnership (LLP)
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p>
            An LLP is an innovative business entity that combines the advantages
            of a limited liability company with the operational flexibility of a
            traditional partnership. Introduced in India in 2009 under the
            Limited Liability Partnership Act of 2008, it serves as a hybrid
            structure ideal for small to medium-sized enterprises and
            professional services. With over one lakh registrations since its
            inception, it requires a minimum of two partners with no upper
            limit, and partners are not liable for each other’s misconduct or
            negligence.
          </p>

          {/* Key Features */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Key Features
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul className="llp-list">
            <li>Minimum of two partners required, with no maximum limit.</li>
            <li>Partners’ liability is limited to their contribution.</li>
            <li>Operates as a separate legal entity.</li>
            <li>Mutual rights governed by an LLP agreement.</li>
            <li>Cannot issue equity shares (unsuitable for equity fundraising).</li>
          </ul>

          {/* Benefits */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Benefits of Registering an LLP
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul className="llp-list">
            <li>
              <strong>Limited Liability:</strong> Partners are liable only up to
              their contribution.
            </li>
            <li>
              <strong>Separate Legal Entity:</strong> LLP can sue or be sued
              independently.
            </li>
            <li>
              <strong>Flexible Ownership:</strong> Easy transfer by inducting new
              partners.
            </li>
            <li>
              <strong>Suitable for Small Businesses:</strong> No audit required if
              capital &lt; Rs. 25 lakhs and turnover &lt; Rs. 40 lakhs.
            </li>
            <li>
              <strong>No Owner/Manager Distinction:</strong> Partners both manage
              and own the business.
            </li>
          </ul>

          {/* Registration Process */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Registration Process
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p>Registering an LLP involves:</p>
          <ol className="llp-list">
            <li>Obtain DSC and DIN for partners.</li>
            <li>Apply for unique name approval via MCA portal.</li>
            <li>File LLP Agreement within 30 days of incorporation (Form 3).</li>
            <li>Submit incorporation documents for registrar approval.</li>
            <li>
              Receive LLP Incorporation Certificate → Apply PAN, TAN, open bank
              account.
            </li>
          </ol>

          {/* Required Documents */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Required Documents
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p>
            For partners: PAN (or passport for foreigners), identity proof, and
            recent bank/utility bill.
          </p>
          <p>
            For registered office: Landlord’s NOC + utility bill (not older than
            2 months).
          </p>

          {/* LLP vs Partnership */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Why Prefer LLP Over Partnership?
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p>
            LLP offers limited liability, unlimited partners, central regulation,
            and perpetual existence compared to traditional partnerships.
          </p>

          {/* LLP vs Private Limited Company */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            LLP vs Private Limited Company
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p>
            Both are MCA-registered, but LLPs are cheaper and better for small
            firms (no audit if turnover &lt; Rs. 40 lakhs). Private Limited
            Companies offer better fundraising options and investor preference.
          </p>

          {/* Conclusion */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Conclusion
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p>
            LLP is an excellent choice for small/medium businesses seeking
            limited liability + operational ease, though not ideal for equity
            funding.
          </p>
        </div>
      </div>

      <Footer />

      {/* Strong mobile overrides so desktop stays untouched */}
      <style>{`
        /* Prevent horizontal overflow and ensure readability */
        .llp-page { overflow-x: hidden; -webkit-overflow-scrolling: touch; }
        .llp-page * { box-sizing: border-box; word-break: break-word; overflow-wrap: break-word; }

        /* Ensure lists look tidy on all sizes */
        .llp-card ul, .llp-card ol { padding-left: 22px; margin-top: 8px; margin-bottom: 12px; }

        /* Tablet */
        @media (max-width: 1024px) {
          .llp-container, .llp-intro {
            max-width: 100% !important;
            width: 100% !important;
            margin: 12px auto !important;
            padding: 12px !important;
          }
          .llp-card { padding: 18px !important; box-shadow: 0 4px 10px rgba(0,0,0,0.06) !important; }
          #llp-header { font-size: 22px !important; padding: 20px 16px !important; margin-top: 65px !important; }
        }

        /* Mobile / small tablets */
        @media (max-width: 768px) {
          .llp-container, .llp-intro {
            width: calc(100% - 32px) !important;
            max-width: calc(100% - 32px) !important;
            margin: 10px auto !important;
            padding: 10px !important;
          }
          .llp-card {
            padding: 14px !important;
            border-radius: 8px !important;
          }
          #llp-header {
            font-size: 20px !important;
            padding: 16px 12px !important;
            margin-top: 65px !important;
          }
          .llp-card h2 { font-size: 18px !important; margin-top: 12px !important; }
          .llp-card p, .llp-card li { font-size: 14px !important; line-height: 1.6 !important; }
          .llp-card ul, .llp-card ol { padding-left: 18px !important; }
        }

        /* Small phones */
        @media (max-width: 480px) {
          .llp-container, .llp-intro {
            width: calc(100% - 24px) !important;
            max-width: calc(100% - 24px) !important;
            padding: 8px !important;
            margin: 8px auto !important;
          }
          .llp-card { padding: 12px !important; border-radius: 6px !important; }
          #llp-header { font-size: 18px !important; padding: 12px 10px !important; }
          .llp-card h2 { font-size: 16px !important; }
          .llp-card p, .llp-card li { font-size: 13px !important; }
        }
      `}</style>
    </div>
  );
};

export default LimitedLiabilityPartnership;
